export const TITULO_REDEFINIR_SENHA = 'Redefinir senha'
export const DESCRICAO_REDEFINIR_SENHA = 'Para redefinir sua senha, digite uma nova senha e confirme.'
export const LABEL_NOVA_SENHA = 'Nova senha'
export const BOTAO_CONFIRMAR = 'Confirmar'
